import { fetchBilling } from '@/lib/api';

export default {
  state: {
    billings: [],
    firstDate: null,
    loading: false,
  },

  getters: {
    getBilling(state) {
      return date => state.billings.find(billing => billing.startDate === date);
    },
    getFirstDate(state) {
      return state.firstDate;
    },
    hasBillingBefore(state) {
      return date => state.firstDate && state.firstDate < date;
    },
    isLoadingBilling(state) {
      return state.loading;
    },
  },

  mutations: {
    addBilling(state, billing) {
      state.billings.push(billing);
    },
    setFirstDate(state, firstDate) {
      state.firstDate = firstDate;
    },
    setLoaderBilling(state, loading) {
      state.loading = loading;
    },
  },

  actions: {
    async fetchBilling({ getters, commit }, date) {
      if (getters.getBilling(date)) {
        return;
      }
      commit('setLoaderBilling', true);
      const firstDateAndInvoice = await fetchBilling.execute(date);
      commit('addBilling', firstDateAndInvoice.invoice);
      commit('setFirstDate', firstDateAndInvoice.firstDate);
      commit('setLoaderBilling', false);
    },
  },
};
